"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const _service_1 = require("~service");
const ui_1 = require("@phishtool/ui");
const feature_flags_1 = require("@phishtool/feature-flags");
const modal_1 = require("@phishtool/modal");
const modalId = 'enterprise-trial';
const StartTrial = ({ token, quote }) => {
    const { professionalFF } = (0, feature_flags_1.useFeatureFlags)();
    const { openModal } = (0, modal_1.useModal)();
    const useMutationResult = _service_1.productTrialService.useCreateProductTrialFromQuote({});
    const onSuccess = () => openModal(modalId);
    (0, ui_1.useMutationToast)({ useMutationResult, onSuccess });
    const onClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        useMutationResult.mutate({
            productType: 'enterprise',
            email: quote.email,
            firstName: quote.firstName,
            lastName: quote.lastName,
            organisation: quote.organisation,
            countryCode: quote.countryCode,
            accessCode: quote.accessCode,
            token,
        });
    });
    if (!professionalFF) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(styled_1.StyledQuoteButton, { href: "#", onClick: onClick, "$disabled": useMutationResult.isLoading, children: [(0, jsx_runtime_1.jsx)("span", { children: "Start free trial" }), useMutationResult.isLoading ? ((0, jsx_runtime_1.jsx)(ui_1.ActivityIndicator, { size: 36 })) : ((0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "trial", size: { width: 34, height: 36 }, alignment: "vertical" }))] }), (0, jsx_runtime_1.jsx)(ui_1.Modal, { id: modalId, heading: "Enterprise Trial", headingSize: "large", children: (0, jsx_runtime_1.jsxs)(ui_1.ModalSuccess, { children: ["A trial invitation has been emailed to ", quote.email] }) })] }));
};
exports.default = StartTrial;
